"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlashMessages = void 0;
const react_1 = require("react");
const service_1 = require("./service");
/**
 * Provides the active flash messages which are currently in the
 * flash message store.
 */
function useFlashMessages() {
    const [state, setState] = (0, react_1.useState)(service_1.flashMessageService.getFlashMessages());
    (0, react_1.useEffect)(() => {
        const subscriber = (nextState) => {
            setState(nextState);
        };
        service_1.flashMessageService.subscribe(subscriber);
        return () => {
            service_1.flashMessageService.unsubscribe(subscriber);
        };
    }, []);
    return state;
}
exports.useFlashMessages = useFlashMessages;
